import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["PostMedia"], {
    "community-talk-store-key": $props.communityTalkStoreKey,
    disabled: $props.disabled,
    "post-type": "Reply",
    "init-post-media-view-models": $setup.replyPostStore.getPostMediaViewModels(),
    onOnSuccessUploadMedias: $setup.onSuccessUploadMedias,
    onOnResetMedias: $setup.onResetMedias,
    onOnStartPostProcess: $setup.onStartPostProcess,
    onOnEndPostProcess: $setup.onEndPostProcess
  }, null, 8 /* PROPS */, ["community-talk-store-key", "disabled", "init-post-media-view-models"]))
}